import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import {classMap} from 'lit/directives/class-map.js';
import {connect} from 'pwa-helpers';
import store from '../../../store';


@customElement('cover-table-item')
export class CoverTableItem extends connect(store)(LitElement) {

	static styles = css`
		.row {
			display: flex;
			padding: var(--sections-gap) 0 var(--sections-gap) 0;
			justify-content: flex-start;
			border-bottom: 1px solid #c6c6c6;
		}

		.row.noBorder {
			border-bottom: none;
		}

		.label {
			display: inline-block;
			font: var(--font-specsheet-bold);
			padding-right: var(--specsheet-feature-padding);
			flex: 1;
		}

		.value {
			font: var(--font-specsheet-light);
			flex: 2;
		}

		@media print {
			:host {
				padding: var(--specsheet-print-feature-padding) 0;
			}

			.row {
				display: flex;
				padding: var(--specsheet-print-small-gap) 0 var(--specsheet-print-small-gap) 0;
				justify-content: flex-start;
				border-bottom: 1px solid #c6c6c6;
			}

			.row.no-border {
				border-bottom: none;
			}

			.label {
				font: var(--font-specsheet-print-bold);
				flex: 1;
			}

			.value {
				font: var(--font-specsheet-print-light);
				flex: 2;
			}
		}

	`;

	@property({type: String})
	key = '';

	@property({type: Boolean})
	compact = false;

	@property({type: Boolean})
	noBorder = false;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.lang = state.status.lang;
	}


	render() {
		return html`
			<div class="row ${classMap({compact: this.compact, noBorder: this.noBorder})}">
				<div class="label">
					<slot name="label">label of feature</slot>
				</div>
				<div class="value">
					<slot name="value">value of feature</slot>
				</div>
			</div>
        `;
	}
}
